import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Button, ButtonGroup } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';

var PageBtn = function PageBtn(_ref) {
  var href = _ref.href,
      page = _ref.page,
      active = _ref.active;
  return /*#__PURE__*/_jsx(NextLink, {
    href: href,
    children: /*#__PURE__*/_jsx(Button, {
      mr: "-px" // fontSize={active ? 'xl' : 'md'}
      ,
      color: active ? 'red.200' : 'inherit',
      children: page
    })
  });
};

var Pagination = function Pagination(props) {
  var _props$range;

  var router = useRouter();
  var isSearch = router.pathname.includes('search');
  var range = (_props$range = props.range) !== null && _props$range !== void 0 ? _props$range : 5;
  var items = [];

  var createPageView = function createPageView(index) {
    return /*#__PURE__*/_jsx(PageBtn, {
      href: isSearch ? {
        pathname: router.pathname,
        query: _objectSpread(_objectSpread({}, router.query), {}, {
          page: index
        })
      } : "/".concat(props.slug, "/").concat(index),
      page: index,
      active: props.currentPage === index
    });
  };

  if (props.numOfPages <= range) {
    for (var index = 1; index <= props.numOfPages; index++) {
      items.push(createPageView(index));
    }
  } else {
    var leftSide = range / 2;
    var rightSide = range - leftSide; // If the selected page index is on the default right side of the pagination,
    // we consider that the new right side is made up of it (= only one break element).
    // If the selected page index is on the default left side of the pagination,
    // we consider that the new left side is made up of it (= only one break element).

    if (props.currentPage > props.numOfPages - range / 2) {
      rightSide = props.numOfPages - props.currentPage;
      leftSide = range - rightSide;
    } else if (props.currentPage < range / 2) {
      leftSide = props.currentPage;
      rightSide = range - leftSide;
    }

    var _index;

    var page;
    var marginPagesDisplayed = 2;
    var breakView;

    for (_index = 0; _index < props.numOfPages; _index++) {
      page = _index + 1; // If the page index is lower than the margin defined,
      // the page has to be displayed on the left side of
      // the pagination.

      if (page <= marginPagesDisplayed) {
        items.push(createPageView(page));
        continue;
      } // If the page index is greater than the page count
      // minus the margin defined, the page has to be
      // displayed on the right side of the pagination.


      if (page > props.numOfPages - marginPagesDisplayed) {
        items.push(createPageView(page));
        continue;
      } // If the page index is near the selected page index
      // and inside the defined range (pageRangeDisplayed)
      // we have to display it (it will create the center
      // part of the pagination).


      if (_index >= props.currentPage - leftSide && _index <= props.currentPage + rightSide) {
        items.push(createPageView(page));
        continue;
      }

      if (items[items.length - 1] !== breakView) {
        breakView = /*#__PURE__*/_jsx(Button, {
          mr: "-px",
          children: "..."
        });
        items.push(breakView);
      }
    }
  }

  return /*#__PURE__*/_jsxs(ButtonGroup, {
    size: "sm",
    isAttached: true,
    variant: "outline",
    children: [/*#__PURE__*/_jsx(NextLink, {
      passHref: true,
      href: isSearch ? {
        pathname: router.pathname,
        query: _objectSpread(_objectSpread({}, router.query), {}, {
          page: props.currentPage - 1
        })
      } : "/".concat(props.slug, "/").concat(props.currentPage - 1),
      children: /*#__PURE__*/_jsx(Button, {
        mr: "-px",
        disabled: props.currentPage <= 1,
        children: "Prev"
      })
    }), items, /*#__PURE__*/_jsx(NextLink, {
      passHref: true,
      href: isSearch ? {
        pathname: router.pathname,
        query: _objectSpread(_objectSpread({}, router.query), {}, {
          page: (props.currentPage || 1) + 1
        })
      } : "/".concat(props.slug, "/").concat(props.currentPage + 1),
      children: /*#__PURE__*/_jsx(Button, {
        disabled: props.currentPage >= props.numOfPages,
        children: "Next"
      })
    })]
  });
};

export default Pagination;